import React, {useState} from "react";
import CvEdit from "./CvEdit";
import {getDescription} from "./CvParser";
import CvDetail from "./CvDetail";

const CvGroup = ({data, activeItems}) => {

    const containerstyle = {
        backgroundColor: '#dfaff1',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid black',
        margin: '5px',
    }

    const headerstyle = {
        fontSize: '15px',
        color: 'black',
        margin: '5px',
    }

    return (
        <div style={containerstyle}>
            <div style={headerstyle}>GROUP | {getDescription(data)} | {data?.type}</div>
            <div key={'#'}>
                {data?.['ct:cv']?.map(it => {
                    return <CvDetail key={it?.id || it?.number} data={it} activeItems={data?.activeItems}/>
                })}
            </div>
        </div>
    )
}

export default CvGroup
